import { ELEMENT, TYPE } from '../enum';

export const items = {
	[`${ELEMENT.AIR}`]: {
		[`${TYPE.ALLOY}`]: [
			{
				id: 7215,
				name: 'Broken Needle',
				comment: '',
				quality: 10,
				air: 100,
				earth: 75,
				fire: 50,
				water: 25
			},
			{
				id: 7156,
				name: 'Broken Shuriken',
				comment: '',
				quality: 30,
				air: 80,
				earth: 60,
				fire: 40,
				water: 20
			},
			{
				id: 7214,
				name: 'Bat Cage',
				comment: '',
				quality: 50,
				air: 60,
				earth: 45,
				fire: 30,
				water: 15
			},
			{
				id: 7072,
				name: 'Old Shuriken',
				comment: '',
				quality: 70,
				air: 40,
				earth: 30,
				fire: 20,
				water: 10
			},
			{
				id: 40018,
				name: 'Metallic Gas',
				comment: '',
				quality: 90,
				air: 20,
				earth: 15,
				fire: 10,
				water: 5
			}
		],
		[`${TYPE.BEAST}`]: [
			{
				id: 7106,
				name: 'Antelope Horn',
				comment: '',
				quality: 10,
				air: 100,
				earth: 75,
				fire: 50,
				water: 25
			},
			{
				id: 7101,
				name: 'Peco Peco Feather',
				comment: '',
				quality: 30,
				air: 80,
				earth: 60,
				fire: 40,
				water: 20
			},
			{
				id: 7168,
				name: 'Giant Butterfly Wing',
				comment: '',
				quality: 50,
				air: 60,
				earth: 45,
				fire: 30,
				water: 15
			},
			{
				id: 7116,
				name: 'Harpy Talon',
				comment: '',
				quality: 70,
				air: 40,
				earth: 30,
				fire: 20,
				water: 10
			},
			{
				id: 40014,
				name: 'Poporing Spark',
				comment: '',
				quality: 90,
				air: 20,
				earth: 15,
				fire: 10,
				water: 5
			}
		],
		[`${TYPE.FOOD}`]: [
			{
				id: 513,
				name: 'Banana',
				comment: '',
				quality: 10,
				air: 100,
				earth: 75,
				fire: 50,
				water: 25
			},
			{
				id: 577,
				name: 'Bag of Grain',
				comment: '',
				quality: 30,
				air: 80,
				earth: 60,
				fire: 40,
				water: 20
			},
			{
				id: 520,
				name: 'Hinalle Leaflet',
				comment: '',
				quality: 50,
				air: 60,
				earth: 45,
				fire: 30,
				water: 15
			},
			{
				id: 550,
				name: 'Rice Cake',
				comment: '',
				quality: 70,
				air: 40,
				earth: 30,
				fire: 20,
				water: 10
			},
			{
				id: 40002,
				name: 'Alchemic Food (White)',
				comment: '',
				quality: 90,
				air: 20,
				earth: 15,
				fire: 10,
				water: 5
			}
		],
		[`${TYPE.MAGIC}`]: [
			{
				id: 912,
				name: 'Zargon',
				comment: '',
				quality: 10,
				air: 100,
				earth: 75,
				fire: 50,
				water: 25
			},
			{
				id: 7189,
				name: 'Wooden Heart',
				comment: '',
				quality: 30,
				air: 80,
				earth: 60,
				fire: 40,
				water: 20
			},
			{
				id: 7263,
				name: 'Cat\'s Eye',
				comment: '',
				quality: 50,
				air: 60,
				earth: 45,
				fire: 30,
				water: 15
			},
			{
				id: 7162,
				name: 'Cloud Crumb',
				comment: '',
				quality: 70,
				air: 40,
				earth: 30,
				fire: 20,
				water: 10
			},
			{
				id: 40022,
				name: 'Air Core',
				comment: '',
				quality: 90,
				air: 20,
				earth: 15,
				fire: 10,
				water: 5
			}
		],
		[`${TYPE.SAND}`]: [
			{
				id: 7154,
				name: 'Poisonous Powder',
				comment: '',
				quality: 10,
				air: 100,
				earth: 75,
				fire: 50,
				water: 25
			},
			{
				id: 924,
				name: 'Powder of Butterfly',
				comment: '',
				quality: 30,
				air: 80,
				earth: 60,
				fire: 40,
				water: 20
			},
			{
				id: 1057,
				name: 'Moth Dust',
				comment: '',
				quality: 50,
				air: 60,
				earth: 45,
				fire: 30,
				water: 15
			},
			{
				id: 7001,
				name: 'Mould Powder',
				comment: '',
				quality: 70,
				air: 40,
				earth: 30,
				fire: 20,
				water: 10
			},
			{
				id: 40010,
				name: 'Aromatic Powder',
				comment: '',
				quality: 90,
				air: 20,
				earth: 15,
				fire: 10,
				water: 5
			}
		],
		[`${TYPE.WOOD}`]: [
			{
				id: 1026,
				name: 'Acorn',
				comment: '',
				quality: 10,
				air: 100,
				earth: 75,
				fire: 50,
				water: 25
			},
			{
				id: 7203,
				name: 'Strong Branch',
				comment: '',
				quality: 30,
				air: 80,
				earth: 60,
				fire: 40,
				water: 20
			},
			{
				id: 7195,
				name: 'Slingshot',
				comment: '',
				quality: 50,
				air: 60,
				earth: 45,
				fire: 30,
				water: 15
			},
			{
				id: 7299,
				name: 'Straw Basket',
				comment: '',
				quality: 70,
				air: 40,
				earth: 30,
				fire: 20,
				water: 10
			},
			{
				id: 40006,
				name: 'Fragrant Plant',
				comment: '',
				quality: 90,
				air: 20,
				earth: 15,
				fire: 10,
				water: 5
			}
		],
	},
	[`${ELEMENT.EARTH}`]: {
		[`${TYPE.ALLOY}`]: [
			{
				id: 1010,
				name: 'Phracon',
				comment: '',
				quality: 10,
				air: 25,
				earth: 100,
				fire: 75,
				water: 50
			},
			{
				id: 1002,
				name: 'Iron Ore',
				comment: '',
				quality: 30,
				air: 20,
				earth: 80,
				fire: 60,
				water: 40
			},
			{
				id: 7016,
				name: 'Spoon Stub',
				comment: '',
				quality: 50,
				air: 15,
				earth: 60,
				fire: 45,
				water: 30
			},
			{
				id: 7095,
				name: 'Metal Fragment',
				comment: '',
				quality: 70,
				air: 10,
				earth: 40,
				fire: 30,
				water: 20
			},
			{
				id: 40017,
				name: 'Fusion Alloy',
				comment: '',
				quality: 90,
				air: 5,
				earth: 20,
				fire: 15,
				water: 10
			},
		],
		[`${TYPE.BEAST}`]: [
			{
				id: 1062,
				name: 'Jack o\' Pumpkin',
				comment: '',
				quality: 10,
				air: 25,
				earth: 100,
				fire: 75,
				water: 50
			},
			{
				id: 1012,
				name: 'Frill',
				comment: '',
				quality: 30,
				air: 20,
				earth: 80,
				fire: 60,
				water: 40
			},
			{
				id: 1096,
				name: 'Round Shell',
				comment: '',
				quality: 50,
				air: 15,
				earth: 60,
				fire: 45,
				water: 30
			},
			{
				id: 7155,
				name: 'Poisonous Toad Skin',
				comment: '',
				quality: 70,
				air: 10,
				earth: 40,
				fire: 30,
				water: 20
			},
			{
				id: 40013,
				name: 'Stapo Spark',
				comment: '',
				quality: 90,
				air: 5,
				earth: 20,
				fire: 15,
				water: 10
			},
		],
		[`${TYPE.FOOD}`]: [
			{
				id: 535,
				name: 'Pumpkin',
				comment: '',
				quality: 10,
				air: 25,
				earth: 100,
				fire: 75,
				water: 50
			},
			{
				id: 581,
				name: 'Edible Mushroom',
				comment: '',
				quality: 30,
				air: 20,
				earth: 80,
				fire: 60,
				water: 40
			},
			{
				id: 508,
				name: 'Yellow Herb',
				comment: '',
				quality: 50,
				air: 15,
				earth: 60,
				fire: 45,
				water: 30
			},
			{
				id: 549,
				name: 'Yam',
				comment: '',
				quality: 70,
				air: 10,
				earth: 40,
				fire: 30,
				water: 20
			},
			{
				id: 40001,
				name: 'Alchemic Food (Green)',
				comment: '',
				quality: 90,
				air: 5,
				earth: 20,
				fire: 15,
				water: 10
			},
		],
		[`${TYPE.MAGIC}`]: [
			{
				id: 911,
				name: 'Scell',
				comment: '',
				quality: 10,
				air: 25,
				earth: 100,
				fire: 75,
				water: 50
			},
			{
				id: 953,
				name: 'Stone Heart',
				comment: '',
				quality: 30,
				air: 20,
				earth: 80,
				fire: 60,
				water: 40
			},
			{
				id: 7321,
				name: 'Crystal Fragment',
				comment: '',
				quality: 50,
				air: 15,
				earth: 60,
				fire: 45,
				water: 30
			},
			{
				id: 7117,
				name: 'Torn Magic Book',
				comment: '',
				quality: 70,
				air: 10,
				earth: 40,
				fire: 30,
				water: 20
			},
			{
				id: 40021,
				name: 'Earth Core',
				comment: '',
				quality: 90,
				air: 5,
				earth: 20,
				fire: 15,
				water: 10
			},
		],
		[`${TYPE.SAND}`]: [
			{
				id: 7452,
				name: 'Yellow Spice',
				comment: '',
				quality: 10,
				air: 25,
				earth: 100,
				fire: 75,
				water: 50
			},
			{
				id: 7264,
				name: 'Dry Sand',
				comment: '',
				quality: 30,
				air: 20,
				earth: 80,
				fire: 60,
				water: 40
			},
			{
				id: 7043,
				name: 'Fine Sand',
				comment: '',
				quality: 50,
				air: 15,
				earth: 60,
				fire: 45,
				water: 30
			},
			{
				id: 7067,
				name: 'Stone Fragment',
				comment: '',
				quality: 70,
				air: 10,
				earth: 40,
				fire: 30,
				water: 20
			},
			{
				id: 40009,
				name: 'Refined Powder',
				comment: '',
				quality: 90,
				air: 5,
				earth: 20,
				fire: 15,
				water: 10
			},
		],
		[`${TYPE.WOOD}`]: [
			{
				id: 1019,
				name: 'Trunk',
				comment: '',
				quality: 10,
				air: 25,
				earth: 100,
				fire: 75,
				water: 50
			},
			{
				id: 7188,
				name: 'Brown Root',
				comment: '',
				quality: 30,
				air: 20,
				earth: 80,
				fire: 60,
				water: 40
			},
			{
				id: 7201,
				name: 'Log',
				comment: '',
				quality: 50,
				air: 15,
				earth: 60,
				fire: 45,
				water: 30
			},
			{
				id: 7196,
				name: 'Shoulder Protector',
				comment: '',
				quality: 70,
				air: 10,
				earth: 40,
				fire: 30,
				water: 20
			},
			{
				id: 40005,
				name: 'Tea Plant',
				comment: '',
				quality: 90,
				air: 5,
				earth: 20,
				fire: 15,
				water: 10
			},
		],
	},
	[`${ELEMENT.FIRE}`]: {
		[`${TYPE.ALLOY}`]: [
			{
				id: 1041,
				name: 'Lantern',
				comment: '',
				quality: 10,
				air: 50,
				earth: 25,
				fire: 100,
				water: 75
			},
			{
				id: 7319,
				name: 'Used Iron Plate',
				comment: '',
				quality: 30,
				air: 40,
				earth: 20,
				fire: 80,
				water: 60
			},
			{
				id: 7120,
				name: 'Burning Horseshoe',
				comment: '',
				quality: 50,
				air: 30,
				earth: 15,
				fire: 60,
				water: 45
			},
			{
				id: 7512,
				name: 'Burnt Part',
				comment: '',
				quality: 70,
				air: 20,
				earth: 10,
				fire: 40,
				water: 30
			},
			{
				id: 40016,
				name: 'Precious Steel',
				comment: '',
				quality: 90,
				air: 10,
				earth: 5,
				fire: 20,
				water: 15
			}
		],
		[`${TYPE.BEAST}`]: [
			{
				id: 919,
				name: 'Animal Skin',
				comment: '',
				quality: 10,
				air: 50,
				earth: 25,
				fire: 100,
				water: 75
			},
			{
				id: 1036,
				name: 'Dragon Scale',
				comment: '',
				quality: 30,
				air: 40,
				earth: 20,
				fire: 80,
				water: 60
			},
			{
				id: 1022,
				name: 'Nine Tails',
				comment: '',
				quality: 50,
				air: 30,
				earth: 15,
				fire: 60,
				water: 45
			},
			{
				id: 7009,
				name: 'Glitter Shell',
				comment: '',
				quality: 70,
				air: 20,
				earth: 10,
				fire: 40,
				water: 30
			},
			{
				id: 40012,
				name: 'Magmaring Spark',
				comment: '',
				quality: 90,
				air: 10,
				earth: 5,
				fire: 20,
				water: 15
			}
		],
		[`${TYPE.FOOD}`]: [
			{
				id: 517,
				name: 'Meat',
				comment: 'Tasty but also a cheap material for alchemy. Purchasable from shop.',
				quality: 10,
				air: 50,
				earth: 25,
				fire: 100,
				water: 75
			},
			{
				id: 580,
				name: 'Bread',
				comment: 'Staple food for humans and the cauldron. Purchasable from shop.',
				quality: 30,
				air: 40,
				earth: 20,
				fire: 80,
				water: 60
			},
			{
				id: 553,
				name: 'Bao',
				comment: '',
				quality: 50,
				air: 30,
				earth: 15,
				fire: 60,
				water: 45
			},
			{
				id: 539,
				name: 'Piece of Cake',
				comment: '',
				quality: 70,
				air: 20,
				earth: 10,
				fire: 40,
				water: 30
			},
			{
				id: 40000,
				name: 'Alchemic Food (Red)',
				comment: '',
				quality: 90,
				air: 10,
				earth: 5,
				fire: 20,
				water: 15
			}
		],
		[`${TYPE.MAGIC}`]: [
			{
				id: 1000,
				name: 'Star Crumb',
				comment: '',
				quality: 10,
				air: 50,
				earth: 25,
				fire: 100,
				water: 75
			},
			{
				id: 7097,
				name: 'Burning Heart',
				comment: '',
				quality: 30,
				air: 40,
				earth: 20,
				fire: 80,
				water: 60
			},
			{
				id: 923,
				name: 'Evil Horn',
				comment: '',
				quality: 50,
				air: 30,
				earth: 15,
				fire: 60,
				water: 45
			},
			{
				id: 7099,
				name: 'Worn-out Magic Scroll',
				comment: '',
				quality: 70,
				air: 20,
				earth: 10,
				fire: 40,
				water: 30
			},
			{
				id: 40020,
				name: 'Fire Core',
				comment: '',
				quality: 90,
				air: 10,
				earth: 5,
				fire: 20,
				water: 15
			}
		],
		[`${TYPE.SAND}`]: [
			{
				id: 7456,
				name: 'Red Spice',
				comment: '',
				quality: 10,
				air: 50,
				earth: 25,
				fire: 100,
				water: 75
			},
			{
				id: 1056,
				name: 'Grit',
				comment: '',
				quality: 30,
				air: 40,
				earth: 20,
				fire: 80,
				water: 60
			},
			{
				id: 7041,
				name: 'Fine Grit',
				comment: '',
				quality: 50,
				air: 30,
				earth: 15,
				fire: 60,
				water: 45
			},
			{
				id: 7096,
				name: 'Lava',
				comment: '',
				quality: 70,
				air: 20,
				earth: 10,
				fire: 40,
				water: 30
			},
			{
				id: 40008,
				name: 'Warmth Powder',
				comment: '',
				quality: 90,
				air: 10,
				earth: 5,
				fire: 20,
				water: 15
			}
		],
		[`${TYPE.WOOD}`]: [
			{
				id: 1033,
				name: 'Maneater Root',
				comment: '',
				quality: 10,
				air: 50,
				earth: 25,
				fire: 100,
				water: 75
			},
			{
				id: 1003,
				name: 'Coal',
				comment: '',
				quality: 30,
				air: 40,
				earth: 20,
				fire: 80,
				water: 60
			},
			{
				id: 7068,
				name: 'Burnt Tree',
				comment: '',
				quality: 50,
				air: 30,
				earth: 15,
				fire: 60,
				water: 45
			},
			{
				id: 7098,
				name: 'Live Coal',
				comment: '',
				quality: 70,
				air: 20,
				earth: 10,
				fire: 40,
				water: 30
			},
			{
				id: 40004,
				name: 'Everdry Plant',
				comment: '',
				quality: 90,
				air: 10,
				earth: 5,
				fire: 20,
				water: 15
			}
		],
	},
	[`${ELEMENT.WATER}`]: {
		// 11,15,19
		[`${TYPE.ALLOY}`]: [

			{
				id: 7317,
				name: 'Rusty Screw',
				comment: '',
				quality: 10,
				air: 75,
				earth: 50,
				fire: 25,
				water: 100
			},
			{
				id: 941,
				name: 'Nose Ring',
				comment: '',
				quality: 30,
				air: 60,
				earth: 40,
				fire: 20,
				water: 80
			},
			{
				id: 7208,
				name: 'Rusty Kitchen Knife',
				comment: '',
				quality: 50,
				air: 45,
				earth: 30,
				fire: 15,
				water: 60
			},
			{
				id: 1064,
				name: 'Reins',
				comment: '',
				quality: 70,
				air: 30,
				earth: 20,
				fire: 10,
				water: 40
			},
			{
				id: 40019,
				name: 'Quicksilver',
				comment: '',
				quality: 90,
				air: 15,
				earth: 10,
				fire: 5,
				water: 20
			},

		],
		[`${TYPE.BEAST}`]: [
			{
				id: 1052,
				name: 'Single Cell',
				comment: '',
				quality: 10,
				air: 75,
				earth: 50,
				fire: 25,
				water: 100
			},
			{
				id: 959,
				name: 'Stinky Scale',
				comment: '',
				quality: 30,
				air: 60,
				earth: 40,
				fire: 20,
				water: 80
			},
			{
				id: 1015,
				name: 'Tongue',
				comment: '',
				quality: 50,
				air: 45,
				earth: 30,
				fire: 15,
				water: 60
			},
			{
				id: 702,
				name: 'Animal Gore',
				comment: '',
				quality: 70,
				air: 30,
				earth: 20,
				fire: 10,
				water: 40
			},
			{
				id: 40015,
				name: 'Pouring Spark',
				comment: '',
				quality: 90,
				air: 15,
				earth: 10,
				fire: 5,
				water: 20
			},
		],
		[`${TYPE.FOOD}`]: [
			{
				id: 512,
				name: 'Apple',
				comment: '',
				quality: 10,
				air: 75,
				earth: 50,
				fire: 25,
				water: 100
			},
			{
				id: 579,
				name: 'Fresh Fish',
				comment: '',
				quality: 30,
				air: 60,
				earth: 40,
				fire: 20,
				water: 80
			},
			{
				id: 518,
				name: 'Honey',
				comment: '',
				quality: 50,
				air: 45,
				earth: 30,
				fire: 15,
				water: 60
			},
			{
				id: 521,
				name: 'Aloe Leaflet',
				comment: '',
				quality: 70,
				air: 30,
				earth: 20,
				fire: 10,
				water: 40
			},
			{
				id: 40003,
				name: 'Alchemic Food (Blue)',
				comment: '',
				quality: 90,
				air: 15,
				earth: 10,
				fire: 5,
				water: 20
			},
		],
		[`${TYPE.MAGIC}`]: [
			{
				id: 910,
				name: 'Garlet',
				comment: '',
				quality: 10,
				air: 75,
				earth: 50,
				fire: 25,
				water: 100
			},
			{
				id: 7220,
				name: 'Ectoplasm',
				comment: '',
				quality: 30,
				air: 60,
				earth: 40,
				fire: 20,
				water: 80
			},
			{
				id: 7066,
				name: 'Ice Cubic',
				comment: '',
				quality: 50,
				air: 45,
				earth: 30,
				fire: 15,
				water: 60
			},
			{
				id: 609,
				name: 'Amulet',
				comment: '',
				quality: 70,
				air: 30,
				earth: 20,
				fire: 10,
				water: 40
			},
			{
				id: 40023,
				name: 'Water Core',
				comment: '',
				quality: 90,
				air: 15,
				earth: 10,
				fire: 5,
				water: 20
			},
		],
		[`${TYPE.SAND}`]: [
			{
				id: 7004,
				name: 'Mud Lump',
				comment: '',
				quality: 10,
				air: 75,
				earth: 50,
				fire: 25,
				water: 100
			},
			{
				id: 7124,
				name: 'Sand Clump',
				comment: '',
				quality: 30,
				air: 60,
				earth: 40,
				fire: 20,
				water: 80
			},
			{
				id: 7149,
				name: 'Yellow Plate',
				comment: '',
				quality: 50,
				air: 45,
				earth: 30,
				fire: 15,
				water: 60
			},
			{
				id: 7158,
				name: 'Broken Liquor Jar',
				comment: '',
				quality: 70,
				air: 30,
				earth: 20,
				fire: 10,
				water: 40
			},
			{
				id: 40011,
				name: 'Chilling Powder',
				comment: '',
				quality: 90,
				air: 15,
				earth: 10,
				fire: 5,
				water: 20
			},
		],
		[`${TYPE.WOOD}`]: [
			{
				id: 902,
				name: 'Tree Root',
				comment: '',
				quality: 10,
				air: 75,
				earth: 50,
				fire: 25,
				water: 100
			},
			{
				id: 930,
				name: 'Rotten Bandage',
				comment: '',
				quality: 30,
				air: 60,
				earth: 40,
				fire: 20,
				water: 80
			},
			{
				id: 7218,
				name: 'Decomposed Rope',
				comment: '',
				quality: 50,
				air: 45,
				earth: 30,
				fire: 15,
				water: 60
			},
			{
				id: 7266,
				name: 'Denture from Dragon Mask',
				comment: '',
				quality: 70,
				air: 30,
				earth: 20,
				fire: 10,
				water: 40
			},
			{
				id: 40007,
				name: 'Poisonous Plant',
				comment: '',
				quality: 90,
				air: 15,
				earth: 10,
				fire: 5,
				water: 20
			},
		],
	},
};
